export const TGStatStatLinkRegExp = new RegExp(
  `https?:\/\/tgstat\\.ru\/(?:ru\/)?(?:chat|channel)\/@[0-9a-zA-Z_]+\/stat\/invite-links\/\\d+.*`,
  "i",
)

export const CHECK_AUTH_INTERVAL = 2000
